import { inputStyles } from "../styles/styles";
import { Grid } from "@material-ui/core";
import React from "react";
import BaseWindow from "./public/BaseWindow";
import timeout from "../images/timeout.png";
import { appMessages, getErrorMessage } from "../utils/enums";
import { connect } from "react-redux";

function Waiting(props) {
  const classes = inputStyles();

  return (
    <BaseWindow>
      <Grid item xs={12} style={{ textAlign: "center", marginTop: 50 }}>
        <div style={{ width: "100%" }}>
          <img alt="Fibabanka" src={timeout} width={100} height={100} />
        </div>
        <div style={{ width: "100%" }}>
          <p>
            <b>
              {props.unsuccess.msg && props.unsuccess.msg !== ""
                ? props.unsuccess.msg
                : "NETWORK ERROR"}
            </b>
          </p>
        </div>
      </Grid>
    </BaseWindow>
  );
}

const mapStateToProps = (state) => {
  return {
    unsuccess: state.unsuccess,
  };
};

export default connect(mapStateToProps)(Waiting);
